<!-- 球队管理 -->
<template>
    <div>
        <event-head></event-head>
        <div class="mt-3">
            <el-table :data="personinfo" style="width: 100%" :header-cell-style="{
                color: '#fff',
                fontSize: '14px',
                height: '40px',
                width: '100%',
            }">
                <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
                <el-table-column prop="date" label="月份" align="center"></el-table-column>
                <el-table-column prop="allcount" label="收益金额" align="center"></el-table-column>
                <!-- <el-table-column prop="signcount" label="佣金收益" align="center"></el-table-column>
                <el-table-column prop="saascount" label="SaaS收益" align="center"></el-table-column>
                <el-table-column prop="count" label="合计收益" align="center"></el-table-column> -->
                <el-table-column prop="time" label="结算日期" align="center"></el-table-column>
                <el-table-column label="结算状态" align="center">
                    <template slot-scope="scope">
                        <div :class="scope.row.state ? 'settled' : 'unsettled'">
                            {{ scope.row.state ? '已结算' : '未结算' }}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination layout="total, prev, pager, next" :current-page="pageInfo.page"
            :page-size="pageInfo.pageSize" :total="pageInfo.count"
            @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
        </div>
    </div>
</template>

<script>
import EventHead from '@/common/components/eventHead/EventHead';
export default {
    components: {
        EventHead
    },
    data() {
        return {
            pageInfo: {
                page: 1,
                pageSize: 10,
                count: 0,
            },
            
            personinfo:[
                {
                date:'2025年7月',
                allcount:'¥ 123,456.00',
                signcount:'¥238.00',
                saascount:'¥111,238.00',
                count:'¥111,238.00',
                time:'2025年8月1日',
                state:true // 已结算
                },
                {
                date:'2025年8月',
                allcount:'¥ 123,456.00',
                signcount:'¥238.00',
                saascount:'¥111,238.00',
                count:'¥111,238.00',
                time:'2025年9月1日',
                state:false // 未结算
                },
        ]

        };
    },
    mounted() {

    },
    methods: {


        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
        },
        handleCurrentChange(val) {
            this.pageInfo.page = val;
        },

    },
};
</script>

<style lang="scss" scoped>
.cardinal {
    margin-top: 30px;
}

.addMatch {
    margin-left: 30px;
    font-size: 16px;
    color: #000;

}

/deep/.el-input--small .el-input__inner {
    height: 32px;
    line-height: 32px;
    background-color: transparent;
    opacity: 1;
    border: none;
    border-bottom: 1px solid #9b9b9b;
    color: #fff;
    border-radius: 0;
}

.bottom_btn {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;

    .addVenue {
        color: #fff;
    }
}
</style>